module.exports = __webpack_public_path__ + "static/media/style_img_mob.ec3663f3.png";